import { render, staticRenderFns } from "./detalhesClientes.vue?vue&type=template&id=54c69bd6&scoped=true&"
import script from "./detalhesClientes.vue?vue&type=script&lang=js&"
export * from "./detalhesClientes.vue?vue&type=script&lang=js&"
import style0 from "./detalhesClientes.vue?vue&type=style&index=0&id=54c69bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c69bd6",
  null
  
)

export default component.exports